import "./saveButton.js";
import "./closeButton.js";
import "./saveAndCloseButton";
import "./editButton";
import "./DictSelectField";
import "./uEditor";
import "./CommonButonField";

$WR.defaultRepositories=$WR.defaultRepositories || [];
let rep=$WR.defaultRepositories.find(r=>r.id==='REP-INTERNAL-COMMON');
if (rep) {
  rep.categories.push({
    name: "扩展组件",
    icon: "fa fa-cogs",
    widgets:[
      {
        "name": "保存按钮",
        "xtype": "saveButton",
        "icon": "fa fa-save"
      },
      {
        "name": "编辑按钮",
        "xtype": "editButton",
        "icon": "fa fa-edit"
      },
      {
        "name": "关闭按钮",
        "xtype": "closeButton",
        "icon": "fa fa-close"
      },
      {
        "name": "保存关闭按钮",
        "xtype": "saveAndCloseButton",
        "icon": "fa fa-close"
      },
      {
        "name": "字典选择",
        "xtype": "DictSelectField",
        "icon": "fa fa-book"
      },{
        "name": "百度编辑器",
        "xtype": "UEditorComp",
        "icon": "fa fa-window-maximize"
      },{
        "name": "按钮输出框",
        "xtype": "CommonButtonField",
        "icon": "fa fa-external-link"
      }
    ]
  });
}



// WEBPACK FOOTER //
// ./src/common/formWidget/index.js